<template>
  <DropDownButton
    button-text="Export As"
    :text="false"
    :small="false"
    icon="fas fa-download"
    button-classes="caption pr-3 font-weight-medium"
    :items="fileTypes"
    :close-on-content-click="true"
    :top="true"
    @item-selected="handleFileTypeSelection"
  />
</template>

<script>
import DropDownButton from "@evercam/shared/components/DropDownButton"
import { DownloadTypes } from "@evercam/shared/types"
import { downloadCSV, exportToCSV } from "@evercam/shared/utils"
import { toTitleCase } from "@evercam/shared/utils"
export default {
  name: "ObjectDetectionExportAsBtn",
  components: { DropDownButton },
  props: {
    detections: {
      type: Array,
      required: true,
    },
    timestamp: {
      type: String,
      required: true,
    },
    projectName: {
      type: String,
      required: true,
    },
    cameraName: {
      type: String,
      required: true,
    },
    userFullName: {
      type: String,
      required: true,
    },
  },

  computed: {
    fileTypes() {
      return [
        {
          name: "CSV (*.csv) ",
          value: DownloadTypes.Csv,
          logo: require("@evercam/shared/assets/img/icons/weather/static/csv.png"),
        },
      ]
    },
    groupedDetectionsData() {
      return this.detections.map((detection) => {
        return {
          detectionType: toTitleCase(detection.id),
          totalCount: detection.count,
        }
      })
    },
  },

  methods: {
    async handleFileTypeSelection() {
      const exportInfo = {
        "Project Name": this.projectName,
        "Camera Name": this.cameraName,
        "Timestamp ": this.timestamp,
        "Created By": this.userFullName,
      }
      const csvData = await exportToCSV({
        data: this.groupedDetectionsData,
        headers: ["detectionType", "totalCount"],
        projectInfo: exportInfo,
      })
      downloadCSV(
        csvData,
        `Object-Detection-${this.cameraName}-${this.timestamp}.csv`
      )
    },
  },
}
</script>
